module.exports = __webpack_public_path__ + "static/media/ZAPTalent-Logotipo-Horizontal-Blanco.b90f11ad.svg";